import React, { memo, ReactElement } from "react";
import classNames from "classnames";

import styles from "../../../styles.scss";

function ExclamationSvgImage(props: { className?: string }): ReactElement {
    return (
        <svg
            className={classNames(styles.exclamationImage, props?.className)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 108 108"
            fill="none"
        >
            <path
                fill="#D07D00"
                d="M106.351 54c0 29.081-23.509 52.65-52.5 52.65C24.858 106.65 1.35 83.081 1.35 54S24.859 1.35 53.85 1.35c28.992 0 52.501 23.569 52.501 52.65Z"
            />
            <path d="M 54 55 L 54 30" fill="transparent" />
            <path d="M 54 55 L 54 30" fill="transparent" stroke="#ffffffab" strokeWidth={12} strokeLinecap="round" />
            <path d="M 54 75 L 54 75.1" fill="transparent" stroke="#ffffffab" strokeWidth={12} strokeLinecap="round" />
        </svg>
    );
}

export default memo(ExclamationSvgImage);
